import { useRef, useContext, useState, useEffect } from 'react';

import styles from './EditProfilePopup.module.css';

import { GlobalContext } from "../contexts/globalContext";

import PopupHeaderComponent from './popup/common/PopupHeaderComponent';
import PopupBodyComponent from './popup/common/PopupBodyComponent';
import PopupBaseComponent from './popup/common/PopupBaseComponent';
import ClosePageButtonComponent from './commons/ClosePageButtonComponent';
import RightBodyComponent from './popup/common/RightBodyComponent';
import LeftBodyComponent from './popup/common/LeftBodyComponent';
import FooterButtonsComponent from './popup/common/FooterButtonsComponent';
import New_InputTextComponent from './keyboard/New_InputTextComponent';

import imageGlasses from '../graphics/header/edit-profile-img.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'


const EditProfilePopup = ({ currentUser, setCurrentUser, }) => {

    const { language, socketRef, setAlertMessage, keyboardRef, setOpenEditProfile, currentConference, setSeeQrCode } = useContext(GlobalContext);

    const inputRefName = useRef();
    const inputRefTelephone = useRef();
    const inputRefOrg = useRef();
    const fromConference = useRef(false);

    const [checkInputs, setCheckInputs] = useState(false);
    const [editedUser, setEditedUser] = useState(false);
    const [qrImage, setQrImage] = useState()

    useEffect(() => {
        if (allFieldsCompleted()) {
            setQrImage(`/assets/cards/${currentUser._id}.png`)
        }
    }, [])

    useEffect(() => {
        if (currentUser) {
            inputRefName.current.value = currentUser.name || "";
            inputRefTelephone.current.value = currentUser.telephone || "";
            inputRefOrg.current.value = currentUser.organization || "";
        }
    }, [currentUser]);

    const allFieldsCompleted = () => {
        const name = inputRefName.current?.value?.trim() || "";
        const telephone = inputRefTelephone.current?.value?.trim() || "";
        const organization = inputRefOrg.current?.value?.trim() || "";

        return name.length > 0 && telephone.length > 0 && organization.length > 0 && isPhoneNumber(inputRefTelephone.current?.value);
    };

    const handleInputChange = () => {
        setEditedUser(true)

        if (allFieldsCompleted()) {
            setCheckInputs(true);
        } else {
            setCheckInputs(false);
        }
    };

    const handleNumberChange = (e) => {
        setEditedUser(true)

        if (allFieldsCompleted()) {
            setCheckInputs(true);
        } else {
            setCheckInputs(false);
        }

        
    };

    function isPhoneNumber(str) {
        const validCharsRegex = /^[\d\s+#*\-]+$/;
        const digitCount = (str.match(/\d/g) || []).length;

        return validCharsRegex.test(str) && digitCount >= 3;
    }

    const handleProfileUpdate = () => {
        if (!isPhoneNumber(inputRefTelephone.current.value)) {
            setAlertMessage({ type: "ERROR", message: "The phone number has an invalid format." });
            return;
        }

        const updatedData = {
            name: inputRefName.current.value,
            telephone: inputRefTelephone.current.value,
            organization: inputRefOrg.current.value
        };

        socketRef.current.emit("UPDATE_USER_PROFILE", { updatedData, userId: currentUser._id }, (response) => {
            if (!response.error) {
                setCurrentUser(response.user);
                setAlertMessage({ type: "SUCCESS", message: response.message })

                if (currentConference) {
                    setSeeQrCode(true)
                    createVCard()
                    fromConference.current = true
                } else {
                    setOpenEditProfile(false);
                }
            } else {
                setAlertMessage({ type: "ERROR", message: response.message || "Profile update failed." });
            }
        });
    };

    function createVCard() {
        socketRef.current.emit("CREATE_VCARD", currentUser._id, (data) => {
            if (data.error) {
                setAlertMessage({ type: "ERROR", message: data.message || "Profile update failed." });
            } else {
                setQrImage(data.path.substring(data.path.indexOf("/assets")))
                setEditedUser(false)

                if(fromConference.current){
                    setOpenEditProfile(false);
                    fromConference.current = false
                }
            }
        });
    }

    const refreshVCard = () => {
        if (!isPhoneNumber(inputRefTelephone.current.value)) {
            setAlertMessage({ type: "ERROR", message: "The phone number has an invalid format." });
            return;
        }

        const updatedData = {
            name: inputRefName.current.value,
            telephone: inputRefTelephone.current.value,
            organization: inputRefOrg.current.value
        };

        socketRef.current.emit("UPDATE_USER_PROFILE", { updatedData, userId: currentUser._id }, (response) => {
            if (!response.error) {
                setCurrentUser(response.user);
                setAlertMessage({ type: "SUCCESS", message: response.message })
                createVCard()
            } else {
                setAlertMessage({ type: "ERROR", message: response.message || "Profile update failed." });
            }
        });
    }



    return (
        <PopupBaseComponent>
            <PopupHeaderComponent text={language.common['Edit Profile']} />
            <PopupBodyComponent style={{ width: 3524, height: 1006, top: "12%" }}>
                <LeftBodyComponent givenWidth="800px" title="Manage your profile" description="Keep your details up to date, including your name, phone number, and organization."
                    image={imageGlasses} borderRight="2px solid #484060" />
                <RightBodyComponent width={2750} flex={true}>
                    <div className={styles.editProfile}>
                        <div className={styles.bodyDetails}>
                            <div className={styles.title}>Name</div>
                            <New_InputTextComponent ref={inputRefName} keyboardRef={keyboardRef} value="" icon={byPrefixAndName.fas["pen"]} iconPosition="right" withDelete={true}
                                placeHolder="Enter name here" styleType='POPUP' width="1440px" height="80px" fontSize="40px" onChange={handleInputChange} />
                            <div className={styles.row}>
                                <div>
                                    <div className={styles.title}>Phone</div>
                                    <New_InputTextComponent ref={inputRefTelephone} keyboardRef={keyboardRef} value="" placeHolder="Enter telephone here" iconPosition="right" withDelete={true}
                                        onChange={handleNumberChange} styleType='POPUP' width="700px" height="80px" fontSize="40px" />
                                </div>
                                <div>
                                    <div className={styles.title}>Organization</div>
                                    <New_InputTextComponent ref={inputRefOrg} keyboardRef={keyboardRef} value="" placeHolder="Enter organization here" iconPosition="right" withDelete={true}
                                        onChange={handleInputChange} styleType='POPUP' width="700px" height="80px" fontSize="40px" />
                                </div>

                            </div>
                        </div>

                        <div style={{ marginLeft: 20, top: 1004, position: "absolute" }}>
                            <FooterButtonsComponent
                                lightText={"Save"}
                                isOpaque={!checkInputs}
                                lightClick={checkInputs ? handleProfileUpdate : () => { }}
                                darkClick={() => setOpenEditProfile(false)}
                            />
                        </div>
                    </div>

                    <div className={styles.vCardZone}>
                        <div className={styles.qr} style={{ opacity: allFieldsCompleted() ? 1 : 0.5, pointerEvents: allFieldsCompleted() ? "" : "none" }}>
                            {!qrImage && <FontAwesomeIcon className={styles.qrIcon} icon={byPrefixAndName.fas['qrcode']} />}
                            {qrImage && <img src={process.env.REACT_APP_CMS_URL + qrImage} className={styles.qrData} alt={"qrCode"} />}
                            {((editedUser && qrImage) || !qrImage) && <div className={styles.vCardButton} onClick={refreshVCard}>
                                {!qrImage && <FontAwesomeIcon className={styles.buttonIcon} icon={byPrefixAndName.fas['plus']} />}
                                {qrImage && <FontAwesomeIcon className={styles.buttonIcon} icon={byPrefixAndName.fas['arrows-rotate']} />}
                            </div>}

                        </div>
                        <div className={styles.title}>Your VCard</div>
                        <div className={styles.explanation}>Share your contact information via QR code during conferences and presentations.</div>
                        <div className={styles.warning}>⚠️ All fields are mandatory</div>
                    </div>

                </RightBodyComponent>
                <ClosePageButtonComponent setClose={() => setOpenEditProfile(false)} />
            </PopupBodyComponent>
        </PopupBaseComponent>
    );
};

export default EditProfilePopup;